import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';
import { MenuItem } from '@mui/material';
import { ReactElement, RefObject, useEffect, useState } from 'react';

import { useWindowSize } from 'hooks';
import { theme } from 'styles';
import { SelectOption } from 'types';

import { CompanySelectBaseTextField } from '../CompanySelectBaseTextField';
import {
  defaultStyles,
  menuItemStyles,
  defaultMobileStyles,
  menuSelectedItemStyles,
} from './styles';

type SelectFieldProps = {
  options: SelectOption[];
  selectedCompany?: { label: string; value: string };
  name?: string;
  id?: string;
  selectRef?: RefObject<HTMLInputElement>;
  onChange?: (value: string, id?: string) => void;
};

export function CompanySelect({
  id,
  options,
  selectedCompany,
  name,
  selectRef,
  onChange,
}: SelectFieldProps): ReactElement {
  const { isMobile } = useWindowSize();
  const label = selectedCompany?.label || '';
  const [value, setValue] = useState(label || '');

  useEffect(() => {
    if (label) {
      setValue(label);
    }
  }, [label]);

  return (
    <>
      <CompanySelectBaseTextField
        id={id}
        inputRef={selectRef}
        name={name}
        onChange={(e) => {
          onChange && onChange(e.target.value, id);
          setValue(options.find((opt) => opt.value === e.target.value)?.label || '');
        }}
        value={value}
        select
        InputProps={{
          sx: {
            ...(isMobile ? defaultMobileStyles : defaultStyles),
            backgroundColor: 'transparent !important',
            '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.02) !important' },
            '&:before, &:after': { display: 'none' },
          },
        }}
        variant="filled"
        SelectProps={{
          disableUnderline: true,
          MenuProps: {
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'left',
            },
            transformOrigin: {
              vertical: 'top',
              horizontal: 'left',
            },
            sx: {
              '.MuiList-root': {
                maxHeight: '320px',
                backgroundColor: theme.palette.info.p080,
                border: 'none',
              },
              '.MuiPaper-root': {
                backgroundColor: theme.palette.info.p080,
                boxShadow: 'none',
                marginTop: isMobile ? -1 : 1,
                border: `1px solid ${theme.palette.primary.grey}`,
              },
            },
            autoFocus: false,
          },
          displayEmpty: true,
          IconComponent: ExpandMoreRoundedIcon,
        }}
      >
        {options.map(({ value: dropDownValue, label }) => {
          const newLabel = label ? `${label}` : '';
          const displayLabel = newLabel.length > 30 ? `${newLabel.slice(0, 30)}...` : label;

          return (
            <MenuItem
              key={dropDownValue}
              value={dropDownValue}
              sx={
                dropDownValue === selectedCompany?.value ? menuSelectedItemStyles : menuItemStyles
              }
            >
              {displayLabel}
            </MenuItem>
          );
        })}
      </CompanySelectBaseTextField>
    </>
  );
}
